import { Howl } from 'howler';
import axios from 'axios';

export default {
    install: function install(Vue) {
        // Event-bus 相当于简单的store
        const bus = new Vue({
            data() {
                return {
                    musicOn: true,
                    musicLoaded: false,
                    audios: {}, // 音频缓冲
                    audioList: {
                        bg: 'http://cdn.shikehuyu.com/card/bg.mp3?v=1.0.1',
                        start: 'http://cdn.shikehuyu.com/card/start.mp3?v=1.0.0',
                        gf: 'http://cdn.shikehuyu.com/card/gf.mp3?v=1.0.0',
                        wsd: 'http://cdn.shikehuyu.com/card/wsd.mp3?v=1.0.0',
                        ymx: 'http://cdn.shikehuyu.com/card/ymx.mp3?v=1.0.0',
                        q1: 'http://cdn.shikehuyu.com/card/q1.mp3?v=1.0.0',
                        q2: 'http://cdn.shikehuyu.com/card/q2.mp3?v=1.0.0',
                        q3: 'http://cdn.shikehuyu.com/card/q3.mp3?v=1.0.1',
                        out: 'http://cdn.shikehuyu.com/card/out.mp3?v=1.0.0',
                        click: 'http://cdn.shikehuyu.com/card/click.mp3?v=1.0.0',
                        success: 'http://cdn.shikehuyu.com/card/success.mp3?v=1.0.0',
                        lottery: 'http://cdn.shikehuyu.com/card/lottery.mp3?v=1.0.0',
                    },
                    total: 300000, // 总人数
                };
            },
            methods: {
                getWxConfig() {
                    return axios({
                        url: 'http://wx.shikehuyu.com/jssdk',
                        params: {
                            url: location.href.split('#')[0]
                        }
                    }).then((response) => {
                        const result = response.data;
                        if (result.code === 0) {
                            return result.package;
                        }
                        return null;
                    });
                },
                configWx(packageData) {
                    if (packageData) {
                        window.wx.config({
                            debug: false,
                            appId: packageData.appId, // 必填，公众号的唯一标识
                            timestamp: packageData.timestamp, // 必填，生成签名的时间戳
                            nonceStr: packageData.nonceStr, // 必填，生成签名的随机串
                            signature: packageData.signature, // 必填，签名
                            jsApiList: [
                                'onMenuShareTimeline', 'onMenuShareAppMessage'
                            ] // 必填，需要使用的JS接口列表
                        });
                        window.wx.ready(() => {
                            window.wx.onMenuShareTimeline({
                                title: '解锁海淘新姿势，广发亚马逊邀你一同来看', // 分享标题
                                link: `http://cdn.shikehuyu.com/card/dist/index.html?tmp=${Date.now()}`,
                                imgUrl: 'http://cdn.shikehuyu.com/card/share.jpg?v=1.0.0', // 分享图标
                            });
                            window.wx.onMenuShareAppMessage({
                                title: '解锁海淘新姿势，广发亚马逊邀你一同来看', // 分享标题
                                desc: '等你来', // 分享描述
                                link: `http://cdn.shikehuyu.com/card/dist/index.html?tmp=${Date.now()}`,
                                imgUrl: 'http://cdn.shikehuyu.com/card/share.jpg?v=1.0.0', // 分享图标
                            });
                        });
                    }
                },

                // 音乐开关
                toggleMusic() {
                    this.musicOn = !this.musicOn;
                },
                // 加载音乐
                loadMusic() {
                    if (!this.musicLoaded) {
                        this.musicLoaded = true;
                        Object.keys(this.audioList).forEach((name) => {
                            this.audios[name] = new Howl({
                                src: this.audioList[name],
                                loop: name === 'bg',
                                volume: name === 'bg' ? 0.5 : 1
                            });
                        });
                    }
                },
                // 播放音乐
                playMusic(name) {
                    if (name in this.audios && this.musicOn) {
                        this.audios[name].play();
                    }
                },
                // 循环音乐
                loopMusic(name) {
                    if (name in this.audios) {
                        this.audios[name].loop(true);
                    }
                },
                // 音乐淡入
                musicFadeIn(name, from = 0, to = 1, duration = 1000) {
                    if (name in this.audios) {
                        this.audios[name].fade(from, to, duration);
                    }
                },
                // 音乐淡出
                musicFadeOut(name, from = 1, to = 0, duration = 1000) {
                    if (name in this.audios) {
                        this.audios[name].fade(from, to, duration);
                    }
                },

                // 跳转办卡
                jump() {
                    location.href = 'http://95508.com/zctFr1Go';
                },
                // 获取访问总人数
                getTotal() {
                    return axios({
                        url: 'http://api.shikehuyu.com/Reward/addAccess'
                    }).then((response) => {
                        const result = response.data;
                        if (result.ret === 200 && result.data.code === 1) {
                            this.total = result.data.num;
                        }
                        return result;
                    }).catch((error) => {
                        console.error(error);
                        this.$emit('showMessage', {
                            message: '系统繁忙'
                        });
                    });
                },
                // 提交表单
                submitForm(data) {
                    return axios({
                        url: 'http://api.shikehuyu.com/Reward/addRecord',
                        method: 'post',
                        data: {
                            user_name: data.name,
                            phone: data.phone
                        }
                    }).then(response => response.data).catch((error) => {
                        console.error(error);
                        this.$emit('showMessage', {
                            message: '系统繁忙'
                        });
                    });
                }
            }
        });

        bus.getTotal();

        bus.getWxConfig().then(bus.configWx);

        /* eslint no-param-reassign: ["error", { "props": false }] */
        Vue.prototype.$bus = bus;
    }
};




// WEBPACK FOOTER //
// ./src/plugin/bus.js